import { useQuery } from 'react-query';

import { httpService } from '../../services/http.service';
import { BASE_URL, USER } from '../../constants/endpoints';
import { HOOKS_SETTINGS } from '../constants';

const { CONTROLLERS: { SCHEDULE_CREATE_FORM: { VERSION, BASE, END } } } = USER;
const { METHOD: { PUT } } = HOOKS_SETTINGS;

export const useGenerateScheduleCFormQuery = ({
  customerId, scheduleCId, year, totalIncome, salary, freelanceIncome, charityDonations, onSuccess, onError,
}: { customerId: string, scheduleCId: string, year: number, totalIncome: number, salary: number, freelanceIncome: number, charityDonations: number, onSuccess?: (data: string)=> void, onError?: () => void }) => useQuery(
  'GenerateScheduleCForm',
  async () => {
    if (!customerId || !scheduleCId || !year || !totalIncome || (!salary && !freelanceIncome)) {
      return null;
    }
    try {
      const { data } = await httpService({
        url: `${BASE_URL}/api/${VERSION}/user/${customerId}/${BASE}/${scheduleCId}/${END}`,
        method: PUT,
        responseType: 'blob',
        data: {
          year,
          totalIncome,
          salary,
          freelanceIncome,
          charityDonations,
        },
      });
      return URL.createObjectURL(data);
    } catch (e) {
      console.error(e);
      return '';
    }
  },
  {
    cacheTime: 0,
    enabled: false,
    onSuccess: (data:string) => { if (onSuccess) onSuccess(data); },
    onError: () => { if (onError) onError(); },
  },
);
